import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    if (user.is_admin) navigate("/admin/dashboard", { replace: true });
    // Non-admin signed-in accounts have no business being on the admin login
    // page — send them straight home. The "not admin" message below is only
    // shown for the brief render before this effect fires.
    else navigate("/", { replace: true });
  }, [user, navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main data-testid="admin-login" className="min-h-screen flex items-center justify-center bg-ivory">
      <div className="w-full max-w-md border border-line p-10 bg-ivory">
        <div className="label-xs text-espresso-light text-center">Admin</div>
        <h1 className="mt-3 font-serif text-4xl text-espresso text-center font-semibold">
          TIRAMISÙ <span className="text-gold">&amp;</span> Co.
        </h1>
        <p className="mt-6 text-espresso-light text-center text-sm">
          Sign in with the owner Google account to manage products, orders and configuration.
        </p>
        {loading ? (
          <div className="mt-8 text-center text-espresso-light label-xs">Checking session…</div>
        ) : (
          <button
            onClick={signIn}
            data-testid="admin-signin-btn"
            className="btn-espresso w-full mt-8"
          >
            Sign in with Google
          </button>
        )}
        {user && !user.is_admin && (
          <div className="mt-4 text-xs text-destructive text-center">
            Signed in as {user.email} — this account is not an admin.
          </div>
        )}
      </div>
    </main>
  );
}
